// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"168":"d528da69","565":"d528da69","699":"9938a559","718":"c87b6202","831":"c87b6202"}[chunkId] + ".chunk.css";
};